import styled from '@emotion/styled';
import { Trans } from '@lingui/react/macro';
import { LinearProgress, Typography } from '@mui/material';

import type { TaskCounts } from '../../../react-query/useGetTasks';
import { usePreferences } from '../../../react-query/usePreferences';

const StyledDiv = styled.div<{ total: number }>`
  margin-bottom: 0.5em;
  display: flex;
  justify-content: flex-end;
  padding: 0 0.5em;

  .progress-bar-container {
    flex-grow: 1;
  }

  .progress-bar-label.MuiTypography-root {
    color: #6f6f7b;
    font-size: 0.6875em;
  }

  .linear-progress-and-total-counts {
    margin-top: 0.5em;
    display: flex;
    align-items: center;
    gap: 0.5em;

    .MuiLinearProgress-root {
      height: 16px;
      flex-grow: 1;
      border-radius: 8px;
      background-color: #d5dadc;
    }

    .MuiLinearProgress-bar {
      border-radius: 8px;
      background-color: ${({ total }) => (total ? '#00A473' : 'transparent')};
    }

    .total-counts.MuiTypography-root {
      color: #6f6f7b;
      font-size: 0.6875em;
      font-weight: 600;
    }
  }
`;

interface Props {
  totalTaskCounts: TaskCounts['total'];
}

export const TaskProgressBar = ({ totalTaskCounts }: Props) => {
  const { data: prefs } = usePreferences();

  const showTaskProgressBar =
    prefs?.taskBitewings !== 0 ||
    prefs.taskPerioChart !== 0 ||
    prefs.taskPerioMaintenance !== 0 ||
    prefs.taskProphy !== 0 ||
    prefs.taskScanOpportunity !== 0 ||
    prefs.taskFluoride !== 0;

  if (!showTaskProgressBar) return null;

  return (
    <StyledDiv total={totalTaskCounts.total}>
      <div className="progress-bar-container">
        <Typography className="progress-bar-label">
          <Trans>Task completion</Trans>
        </Typography>
        <div className="linear-progress-and-total-counts">
          <LinearProgress
            value={(totalTaskCounts.complete / totalTaskCounts.total) * 100}
            variant="determinate"
          />

          <Typography className="total-counts">
            {totalTaskCounts.complete}/{totalTaskCounts.total}
          </Typography>
        </div>
      </div>
    </StyledDiv>
  );
};
